import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { apiMethods, apiEndPoints, common } from '@constants/index';
import {
  IItrInfo,
  IMaritalStatus,
  IItrApiResponse,
  IItrCompleteProfile,
  IMailingDetails,
  IItrBackgroundDetails,
  CraApiResponse,
} from '@core/models/index';

@Injectable()
export class ItrProfileService {
  constructor(private http: ApiService) {}
  public updateIncomeTaxInfo(
    itrInfo: IItrInfo,
    itrId: number
  ): Observable<IItrApiResponse> {
    return this.http.invoke({
      method: !!itrId ? apiMethods.patch : apiMethods.post,
      path: !!itrId ? `${apiEndPoints.itr}/${itrId}` : `${apiEndPoints.itr}`,
      body: itrInfo,
    });
  }

  public incomeTaxDetails(itrId: number): Observable<IItrApiResponse> {
    return this.http.invoke({
      method: apiMethods.get,
      path: `${apiEndPoints.itr}/${itrId}`,
    });
  }

  public updateMaritalStatus(
    maritalData: IMaritalStatus
  ): Observable<IItrApiResponse> {
    const apiPath = `${apiEndPoints.itr}${apiEndPoints.maritalStatus}`;
    return this.http.invoke({
      method: !!maritalData.id ? apiMethods.patch : apiMethods.post,
      path: !!maritalData.id ? `${apiPath}/${maritalData.itr}` : `${apiPath}`,
      body: maritalData,
    });
  }

  public maritalStatusDetails(itrId: number): Observable<IItrApiResponse> {
    const apiPath = `${apiEndPoints.itr}${apiEndPoints.maritalStatus}`;
    return this.http.invoke({
      method: apiMethods.get,
      path: `${apiPath}/${itrId}`,
    });
  }

  public updateCompleteProfile(
    profileData: IItrCompleteProfile
  ): Observable<IItrApiResponse> {
    const apiPath = `${apiEndPoints.itr}${apiEndPoints.completeItrProfile}`;
    return this.http.invoke({
      method: !!profileData.id ? apiMethods.patch : apiMethods.post,
      path: !!profileData.id ? `${apiPath}/${profileData.itr}` : `${apiPath}`,
      body: profileData,
    });
  }

  public completeItrProfile(itrId: number): Observable<IItrApiResponse> {
    const apiPath = `${apiEndPoints.itr}${apiEndPoints.completeItrProfile}`;
    return this.http.invoke({
      method: apiMethods.get,
      path: `${apiPath}/${itrId}`,
    });
  }

  public updateMailingDetails(
    mailingDetails: IMailingDetails
  ): Observable<IItrApiResponse> {
    const apiPath = `${apiEndPoints.itr}${apiEndPoints.mailingDetails}`;
    return this.http.invoke({
      method: !!mailingDetails.id ? apiMethods.patch : apiMethods.post,
      path: !!mailingDetails.id
        ? `${apiPath}/${mailingDetails.itr}`
        : `${apiPath}`,
      body: mailingDetails,
    });
  }

  public mailingDetails(itrId: number): Observable<IItrApiResponse> {
    const apiPath = `${apiEndPoints.itr}${apiEndPoints.mailingDetails}`;
    return this.http.invoke({
      method: apiMethods.get,
      path: `${apiPath}/${itrId}`,
    });
  }

  public updateBackgroundDetails(
    dependentDetails: IItrBackgroundDetails
  ): Observable<IItrApiResponse> {
    const apiPath = `${apiEndPoints.itr}${apiEndPoints.backgroundDetails}`;
    return this.http.invoke({
      method: !!dependentDetails.id ? apiMethods.patch : apiMethods.post,
      path: !!dependentDetails.id
        ? `${apiPath}/${dependentDetails.itr}`
        : `${apiPath}`,
      body: dependentDetails,
    });
  }

  public backgroundDetails(itrId: number): Observable<IItrApiResponse> {
    const apiPath = `${apiEndPoints.itr}${apiEndPoints.backgroundDetails}`;
    return this.http.invoke({
      method: apiMethods.get,
      path: `${apiPath}/${itrId}`,
    });
  }

  public craDetails(
    itrId: number,
    taxyear: number
  ): Observable<CraApiResponse> {
    const apiPath = `${apiEndPoints.itr}${apiEndPoints.afr}${apiEndPoints.initiate}/?itr=${itrId}&tax_year=${taxyear}`;
    return this.http.invoke({
      method: apiMethods.get,
      path: `${apiPath}`,
    });
  }
  public loginWithCra(craurl: any): Observable<CraApiResponse> {
    const apiPath = `/${apiEndPoints.itr}${apiEndPoints.afr}${apiEndPoints.fetch_return_data}/?token_url=${craurl}&tax_year=${common.tax_year}`;
    return this.http.invoke({
      method: apiMethods.get,
      path: `${apiPath}`,
    });
  }
}
